import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean | UrlTree> => {
  const { authenticated, grantedRoles } = authData;

  const hasRequiredRole = (role: string): boolean => {
    const resourceMatch = Object.values(grantedRoles.resourceRoles || {}).some((roles) => roles.includes(role));
    const realmMatch = (grantedRoles.realmRoles || []).includes(role);
    return resourceMatch || realmMatch;
  };

  const requiredRoles: string[] | undefined = route.data['roles'];
  const requiredRole: string | undefined = route.data['role'];

  const rolesToCheck = requiredRoles ?? (requiredRole ? [requiredRole] : null);
  if (!rolesToCheck) {
    return false;
  }

  if (authenticated && rolesToCheck.some(hasRequiredRole)) {
    return true;
  }

  const router = inject(Router);
  return router.parseUrl('/forbidden');
};

export const canActivateAuthRole = createAuthGuard<CanActivateFn>(isAccessAllowed);
